<template>
    <app-wrapper>
        <app-header
            :page="'Profile'"
            medium-max-width="max-w-1000"
            medium-max-width-inner="max-w-500">

            <template #navigation />

            <template #top>
                <div class="flex items-center">
                    <div class="flex-initial p-4">
                        <svg class="w-17" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="35" cy="35" r="34.5" fill="#F4F7FD" stroke="#DBE3EE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M47.0927 41.5011C45.0852 38.8165 42.4961 37.4281 38.121 36.9821C37.3314 36.8195 36.7362 36.1036 36.7362 35.2534C36.7362 34.6309 38.6881 32.7672 38.6742 32.7534C40.6889 30.6215 41.769 27.1574 41.769 24.4942C41.769 20.3577 38.5151 17 34.4999 17C30.4847 17 27.2307 20.3577 27.2307 24.4942C27.2307 27.1719 28.2831 30.6568 30.3185 32.7888C30.3185 32.7888 32.2638 34.631 32.2638 35.2535C32.2638 36.1534 31.5993 36.9038 30.7407 37.0105C26.4552 37.4709 23.894 38.8517 21.9069 41.5012C21.3323 42.2661 21.0206 43.8032 21 44.6252C21.0069 44.8376 21 48.1668 21 48.1668C21 49.7322 22.2393 51 23.7693 51H45.2305C46.7605 51 48 49.7322 48 48.1668C48 48.1668 47.9932 44.8376 48 44.6252C47.9795 43.8031 47.6671 42.266 47.0927 41.5011Z" fill="#C9D6F0"/>
                        </svg>
                    </div>
                    <div class="flex-auto">
                        <h4 class="mb-1.5 leading-tight">{{ $root.user.full_name }}</h4>
                        <p>{{ $root.user.email }}</p>
                    </div>
                </div>
            </template>

        </app-header>
        <app-body medium-max-width="max-w-500" footer short>

            <template #main>
                <div class="flex flex-col space-y-4">
<!--                    <a v-for="(loan, i) in loans"-->
<!--                       :href="`/account/loans/${loan.id}`"-->
<!--                       class="block no-underline w-full shadow-floating bg-white rounded-lg text-black">-->
<!--                        <div class="flex items-center justify-between py-3 px-4">-->

<!--                            <p class="text-sm font-semibold">Loan #1347197</p>-->
<!--                            <span v-if="loan.status === 'current'" class="rounded-full bg-success text-white text-xs font-semibold py-1 px-2.5">-->
<!--                                On Track-->
<!--                            </span>-->
<!--                            <span v-else-if="loan.status === 'past_due'" class="rounded-full bg-danger text-white text-xs font-semibold py-1 px-2.5">-->
<!--                                Past Due-->
<!--                            </span>-->

<!--                        </div>-->
<!--                        <div class="w-full h-2 bg-gray-100 rounded-b-lg">-->
<!--                            <div class="bg-action rounded-bl-lg w-1/3 h-2" />-->
<!--                        </div>-->
<!--                    </a>-->

                    <div class="border rounded-lg bg-gray-50 border-gray-200">
                        <div class="flex justify-between items-center bottom-line p-4">
                            <h6 v-if="! editing" class="text-base font-semibold">Personal Information</h6>
                            <h6 v-else @click.prevent="() => { copyUserProperties(); editing = false }" class="cursor-pointer text-base font-semibold">Cancel</h6>

                            <a v-if="canEditIdentity && ! editing" @click.prevent="editing = true" data-testid="edit-personal-information" class="cursor-pointer font-semibold no-underline text-sm edit-button">Edit</a>
                            <a v-else-if="editing" @click.prevent="save" class="cursor-pointer font-semibold no-underline text-sm" data-testid="save-personal-information">
                                <template v-if="! editingLoading">
                                    Save Changes
                                </template>
                                <template v-else>
                                    <i class="fa fa-circle-notch fa-spin" />
                                </template>
                            </a>
                        </div>
                        <profile-list v-if="! editing" />
                        <profile-form v-else
                                      :errors="editingErrors"
                                      :annual_income.sync="editingForm.annual_income"
                                      :date_of_birth.sync="editingForm.date_of_birth"
                                      :phone_number.sync="editingForm.phone_number"
                                      :first_name.sync="editingForm.first_name"
                                      :middle_name.sync="editingForm.middle_name"
                                      :last_name.sync="editingForm.last_name"
                                      :address="editingForm.address"
                                      :address2.sync="editingForm.address2"
                                      :zip.sync="editingForm.zip"
                                      :monthly_income.sync="editingForm.monthly_income"
                                      :income_source.sync="editingForm.income_source"
                                      @update:zip="editingForm.zip = $event"
                                      @update:address="updateAddress"
                        />
                    </div>

                    <div v-if="$root.user.referral_id" class="border rounded-lg bg-gray-50 border-gray-200">
                        <div class="flex justify-between items-center bottom-line p-4">
                            <h6 class="text-base font-semibold">Referral</h6>
                            <h6 class="text-base font-semibold text-green-500">Earn up to $100 by referring someone!</h6>
                        </div>
                        <div>
                            <div class="bottom-line p-4 flex justify-between items-center space-x-4">
                                <div class="flex-none">
                                    <div class="flex justify-between">
                                        <div class="flex-initial">
                                            <label for="date_of_birth" class="text-sm">By Email</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0 sm:space-x-4">
                                    <input v-model="referralEmail"
                                           type="text"
                                           id="email"
                                           name="email"
                                           placeholder="Email Address"
                                           class="input-field w-full"
                                           @keydown.enter="sendReferral" />
                                    <a href="#" @click.prevent="sendReferral" class="text-white w-full sm:w-auto bg-primary text-center mx-2 no-underline font-medium pt-2 pb-2 px-3 border border-gray-50 rounded cursor-pointer text-sm">
                                        <template v-if="referralLoading">
                                            <i class="fa fa-circle-notch fa-spin text-white" />
                                        </template>
                                        <template v-else-if="referralSuccess">
                                            <i class="fa fa-check-double text-white" />
                                        </template>
                                        <template v-else-if="referralFailure">
                                            <i class="fa fa-exclamation-circle text-white" />
                                        </template>
                                        <template v-else>
                                            Send
                                        </template>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="bottom-line p-4 flex justify-between items-center space-x-4">
                                <p class="flex-none">
                                    By Link
                                </p>
                                <p class="font-semibold break-all sm:pl-0 text-justify">
                                    <a data-testid="referral-link" :href="`${$root.app.url}/signup?ref=${$root.user.referral_id}`" @click.prevent="" v-text="`${$root.app.url}/signup?ref=${$root.user.referral_id}`" />
                                </p>
                            </div>
                        </div>
                    </div>

                    <notification-preferences 
                        :unsubscribegroups="unsubscribegroups"
                        :userunsubscribegroups="userunsubscribegroups"    
                    />
                    
                </div>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
    import ProfileForm from './profile/Form';
    import ProfileList from './profile/List';
    import NotificationPreferences from './profile/NotificationPreferences.vue';

    export default {
        props: {
            unsubscribegroups: {
                type: Array,
                default: () => []
            },
            userunsubscribegroups: {
                type: Array,
                default: () => []
            },
            // False during signup / KYC — identity edits go through verification flow.
            canEditIdentity: {
                type: Boolean,
                default: true
            }
        },

        mixins: [
            require('../mixins/InteractsWithGtag').default,
            require('../mixins/InteractsWithLoans').default
        ],

        components: {
            ProfileForm,
            ProfileList,
            NotificationPreferences
        },

        data() {
            return {
                referralEmail: null,
                referralLoading: false,
                referralSuccess: false,
                referralFailure: false,
                gTagPageName: 'profile',
                editing: false,
                editingLoading: false,
                editingErrors: [],
                editingForm: {
                    annual_income: '',
                    date_of_birth: '',
                    phone_number: '',
                    address: '',
                    address2: '',
                    city: '',
                    state: 'WI',
                    zip: '',
                    monthly_income: '',
                    income_source: ''
                }
            }
        },

        created() {
            this.copyUserProperties();
        },

        methods: {
            updateAddress(addressObj) {
                this.editingForm.address = addressObj?.address ?? '';
                this.editingForm.city = addressObj?.city ?? '';
                this.editingForm.state = addressObj?.state ?? '';
                this.editingForm.zip = addressObj?.zip ?? '';
            },
            sendReferral() {
                this.referralLoading = true;

                this.$http.post(`/account/profile/refer`, {
                    email: this.referralEmail
                }).then(() => {
                    this.referralLoading = false;
                    this.referralSuccess = true;

                    setTimeout(() => {
                        this.referralSuccess = false;
                        this.referralEmail = '';
                    }, 3000);
                }).catch(error => {
                    this.referralLoading = false;
                    this.referralFailure = true;
                    this.referralEmail = error.response.data.message;

                    setTimeout(() => {
                        this.referralFailure = false;
                        this.referralEmail = '';
                    }, 3000);
                });
            },

            /**
             * @returns {void}
             */
            copyUserProperties() {
                this.editingForm.annual_income = this.$options.filters.number(this.$root.user.annual_income, 0);
                this.editingForm.date_of_birth = this.$root.user?.date_of_birth?.substring(0,10);
                this.editingForm.phone_number = this.$root.user?.phone_number;
                this.editingForm.first_name = this.$root.user?.first_name;
                this.editingForm.middle_name = this.$root.user?.middle_name;
                this.editingForm.last_name = this.$root.user?.last_name;
                this.editingForm.address = this.$root.user?.address;
                this.editingForm.address2 = this.$root.user?.address2;
                this.editingForm.city = this.$root.user?.city;
                this.editingForm.state = this.$root.user?.state;
                this.editingForm.zip = this.$root.user?.zip;
                this.editingForm.monthly_income = this.$options.filters.number(this.$root.user?.monthly_income, 0);
                this.editingForm.income_source = this.$root.user?.income_source;
            },

            /**
             * @returns {void}
             */
            save() {
                this.editingLoading = true;

                // Income is server-managed (not editable via profile) — omit from payload.
                const {
                    annual_income,
                    monthly_income,
                    income_source,
                    ...profilePayload
                } = this.editingForm;

                this.$http.post(`/account/profile`, profilePayload).then(({ data }) => {
                    this.editingErrors = [];
                    this.$root.$emit('updateUser', data);

                    this.editing = false;
                }, error => {
                    this.editingErrors = error.hasOwnProperty('response') ? error.response.data.errors : error;
                }).finally(() => {
                    setTimeout(() => {
                        this.editingLoading = false;
                    }, 250);
                });
            }
        }
    }
</script>